
import { UserTransformer } from '@/helpers/users/user.transformer';
import moment from "moment";
import "moment-timezone";

export class LogTransformer {

    static transform(obj) {
        let log = {};

        log.type = obj.attributes.subtype && obj.attributes.subtype.includes("SYSTEM::")
            ? 'SYSTEM'
            : 'LOGS';

        log.id = obj.id;
        log.loggableType = obj.attributes.loggable_type;
        log.model = obj.attributes.log_type;
        log.loggable_id = obj.attributes.loggable_id;
        log.content = obj.attributes.content;
        log.data = obj.attributes.data;
        log.subtype = obj.attributes.subtype;
        log.created_by = obj.attributes.created_by;
        log.createdBy = obj.attributes.createdBy ? UserTransformer.transform(obj.attributes.createdBy) : null;
        // Timestamps in transformers MUST be in a standard international format.
        // It is up to the template that renders the time to format it because
        // different templates may require time to be rendered differently.
        // (use helper methods and filters to format dates in templates)
        log.createdAt = obj.attributes.created_at;
        return log;
    }

    static transformArray(array = []) {
        let data = [];
        array.map(function (item) {
            data.push(LogTransformer.transform(item));
        });
        return data;
    }
}


// WEBPACK FOOTER //
// ./src/helpers/logs/logs.transformer.js